import { useCallback, useMemo } from "react";
import { Link, router, useGlobalSearchParams } from "expo-router";
import { Button, FormTitle } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, useMedia, YStack } from "tamagui";

import img from "~/assets/signup/signup-1.png";
import { FacebookButton } from "~/component/feature/auth/facebook-button";
import { GoogleButton } from "~/component/feature/auth/google-button";
import { OrSeparator } from "~/component/feature/auth/or-separator";
import type { SocialButtonAuthParams } from "~/component/feature/auth/social-button";
import {
  AuthBaseForm,
  AuthContainer,
  AuthContent,
  AuthImage,
} from "~/component/feature/auth/wrappers";
import { useTrackOnce } from "~/hooks/use-track";

export default function SignupSlugSocialPage() {
  useTrackOnce("Render Signup page");
  const { t } = useTranslation("auth");
  const { sm } = useMedia();

  const { slug } = useGlobalSearchParams<{ slug: string }>();

  const authParams = useMemo<SocialButtonAuthParams>(
    () => ({ additionalData: { slug }, errorCallbackURL: "/s/" + slug }),
    [slug],
  );

  const handlePress = useCallback(() => {
    router.navigate(`/s/${slug}/signup`);
  }, [slug]);

  return (
    <AuthContainer>
      <AuthContent>
        <AuthBaseForm>
          <YStack width={"100%"} gap={"$3"}>
            <FormTitle>{t("title")}</FormTitle>
            <Text fontFamily={"$body"} fontWeight={"$5"}>
              {t("subtitle")}
            </Text>
            <YStack width={"100%"} gap={"$2"} marginTop={"$1"}>
              <GoogleButton authParams={authParams}>
                {t("googleButton")}
              </GoogleButton>
              <FacebookButton authParams={authParams}>
                {t("facebookButton")}
              </FacebookButton>
            </YStack>
            <OrSeparator text={t("orSeparator")} />
            <Button
              rounded="lg"
              variant="outlined"
              size={sm ? "sm" : "md"}
              onPress={handlePress}
            >
              {t("emailButton")}
            </Button>
            <Text
              asChild
              cursor="pointer"
              textAlign="center"
              fontFamily="$body"
              fontSize="$3"
              marginTop="$2"
              textDecorationLine="underline"
              hoverStyle={{ color: "$lightblue-800" }}
            >
              <Link data-id={"link-signin"} href={"/auth"}>
                {t("signinLink")}
              </Link>
            </Text>
          </YStack>
        </AuthBaseForm>
      </AuthContent>
      <AuthImage src={img} />
    </AuthContainer>
  );
}
